/**
 * Стандартный onClick кнопки футера окна — алиас «location-reload»: перезагрузить страницу целиком.
 *
 * Плагин open-modal-url.js (1 файл — 1 функция). Вызывается с аргументами (button, config): оба аргумента здесь не используются.
 */
window.openModalWindowFunctions["location-reload"] = function (element, config) {
    location.reload();
};
